import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <nav style={{
      position:"fixed", top:0, left:0, right:0, zIndex:100,
      padding:"0 5vw", height:"64px",
      display:"flex", alignItems:"center", justifyContent:"space-between",
      background: scrolled ? "rgba(255,255,255,0.93)" : "transparent",
      backdropFilter: scrolled ? "blur(12px)" : "none",
      boxShadow: scrolled ? "0 1px 0 #E7E5E4" : "none",
      transition:"all .3s",
    }}>
      {/* Logo */}
      <div
        onClick={() => window.scrollTo({ top:0, behavior:"smooth" })}
        style={{ display:"flex", alignItems:"center", gap:"10px", cursor:"pointer" }}>
        <div style={{
          width:"36px", height:"36px",
          background:"linear-gradient(135deg,#92400E,#D97706)",
          borderRadius:"10px", display:"flex", alignItems:"center",
          justifyContent:"center", fontSize:"18px",
        }}>🪚</div>
        <span style={{
          fontFamily:"'Fraunces',serif", fontSize:"22px",
          fontWeight:900, color:"#1C1917",
        }}>Craftigo</span>
      </div>

      {/* Buttons */}
      <div style={{ display:"flex", gap:"10px" }}>
        <button
          onClick={() => navigate("/login")}
          style={{
            padding:"9px 18px", borderRadius:"10px",
            border:"1.5px solid #E7E5E4", background:"transparent",
            fontFamily:"'Plus Jakarta Sans',sans-serif",
            fontSize:"14px", fontWeight:600, color:"#44403C", cursor:"pointer",
            transition:"all .15s",
          }}
          onMouseEnter={e => { e.currentTarget.style.background="#FEF3C7"; e.currentTarget.style.borderColor="#D97706"; e.currentTarget.style.color="#92400E"; }}
          onMouseLeave={e => { e.currentTarget.style.background="transparent"; e.currentTarget.style.borderColor="#E7E5E4"; e.currentTarget.style.color="#44403C"; }}>
          Sign In
        </button>
        <button
          onClick={() => navigate("/register")}
          style={{
            padding:"9px 20px", borderRadius:"10px", border:"none",
            background:"linear-gradient(135deg,#B45309,#D97706)",
            fontFamily:"'Plus Jakarta Sans',sans-serif",
            fontSize:"14px", fontWeight:700, color:"#fff", cursor:"pointer",
            boxShadow:"0 4px 14px rgba(180,83,9,.3)", transition:"all .2s",
          }}
          onMouseEnter={e => { e.currentTarget.style.transform="translateY(-1px)"; e.currentTarget.style.boxShadow="0 6px 20px rgba(180,83,9,.4)"; }}
          onMouseLeave={e => { e.currentTarget.style.transform="translateY(0)"; e.currentTarget.style.boxShadow="0 4px 14px rgba(180,83,9,.3)"; }}>
          Get Started
        </button>
      </div>
    </nav>
  );
}